import React, { FC } from 'react';
import styles from './lawyer_keywords.module.scss';
import { LawyerHit } from '../../../../search.types';

type Props = {
  keywords: LawyerHit['keywords'];
};

export const LawyerKeywords: FC<Props> = ({ keywords }) => (
  <ul className={styles.list}>
    {keywords.map(keyword => (
      <li className={styles.item} key={keyword.name}>
        {keyword.name}
      </li>
    ))}
  </ul>
);
